import React from "react";
import "./Sources.css";
import { Helmet } from 'react-helmet';

const Sources = () => {
  return (
    <>
      <Helmet>
        <title>TKD Study - Sources</title>
      </Helmet>
      <div className="sources-container">
        <div className="back-arrow" onClick={() => window.history.back()}>
          ← Back
        </div>

        <div className="sources-card">
          <h2>Sources</h2>
          <p>
            Majority of the information and theory in this webapp is sourced from the 15 volumes of General Choi Hong Hi's <i>Encyclopedia of Taekwon-Do</i>.
            <br /><br />
            Other information and theory is from Legacy Taekwondo's <i>Student Handbook</i> and <i>The Art of Taekwon-Do ITF</i> by the ITF Technical Committee.
            <br /><br />
            All questions are my own and may bear similarity to some questions in Legacy Taekwondo's <i>Student Handbook</i>.
            <br /><br />
            Sparring rules are from itfktd.sport and the <i>Referee and Umpire Training Manual</i> by INTA.
            <br /><br />
            All diagrams are mine and inspired by General Choi Hong Hi's <i>Encyclopedia of Taekwon-Do</i>.
            <br /><br />
            Tenets of Taekwondo are from General Choi Hong Hi's <i>Encyclopedia of Taekwon-Do</i>.
            <br /><br />
            ITF logos, the ITF tree, and the picture of General Choi Hong Hi are from itftkd.sport.
            <br /><br />
            Photography by Mr Niall Reynolds V.
          </p>
        </div>
      </div>
    </>
  );
};

export default Sources;
